import React, { FC } from 'react';

import { MobileErrorMessage } from 'src/apps/mobile-common/components/mobile-error-message/MobileErrorMessage';
import { ProductType } from 'src/common/interfaces/Tenant';
import {
	MOBILE_SDK_NO_TESTS_MSG,
	MOBILE_SDK_NO_TESTS_TITLE
} from 'src/common/pages/dashboards-container/errorMessages';

interface MobileSdkErrorProps {
	isNoData?: boolean;
}

export const MobileSdkError: FC<MobileSdkErrorProps> = ({ isNoData }) => {
	return (
		<MobileErrorMessage
			title={MOBILE_SDK_NO_TESTS_TITLE}
			message={MOBILE_SDK_NO_TESTS_MSG}
			productType={ProductType.MOBILE_SDK}
			isNoData={isNoData}
		/>
	);
};
